export default {
  sections: [
  {
    "id": "serviceCompany",
    "title": "SERVICING COMPANY DETAILS",
    "repeatable": false,
    "fields": [
      {
        "id": "companyName",
        "type": "text",
        "label": "Company Name",
        "required": true
      },
      {
        "id": "oftecRegistration",
        "type": "text",
        "label": "OFTEC Registration Number",
        "required": true
      },
      {
        "id": "engineerName",
        "type": "text",
        "label": "Engineer Name",
        "required": true
      },
      {
        "id": "engineerCardNumber",
        "type": "text",
        "label": "Engineer Card Number",
        "required": true
      },
      {
        "id": "telephone",
        "type": "tel",
        "label": "Telephone",
        "required": true
      }
    ]
  },
  {
    "id": "customer",
    "title": "CUSTOMER & APPLIANCE DETAILS",
    "repeatable": false,
    "fields": [
      {
        "id": "customerName",
        "type": "text",
        "label": "Customer Name",
        "required": true
      },
      {
        "id": "siteAddress",
        "type": "textarea",
        "label": "Site Address",
        "required": true
      },
      {
        "id": "postCode",
        "type": "text",
        "label": "Post Code",
        "required": true
      },
      {
        "id": "applianceType",
        "type": "select",
        "label": "Appliance Type",
        "options": [
          "Floor Standing Boiler",
          "Wall Mounted Boiler",
          "Cooker",
          "Range",
          "Water Heater",
          "Other"
        ],
        "required": true
      },
      {
        "id": "make",
        "type": "text",
        "label": "Make",
        "required": true
      },
      {
        "id": "model",
        "type": "text",
        "label": "Model",
        "required": true
      },
      {
        "id": "serialNumber",
        "type": "text",
        "label": "Serial Number",
        "required": true
      },
      {
        "id": "burnerMake",
        "type": "text",
        "label": "Burner Make"
      },
      {
        "id": "burnerModel",
        "type": "text",
        "label": "Burner Model"
      }
    ]
  },
  {
    "id": "nozzle",
    "title": "NOZZLE & OIL SUPPLY",
    "repeatable": false,
    "fields": [
      {
        "id": "nozzleSize",
        "type": "text",
        "label": "Nozzle Size (US gal/h)",
        "placeholder": "e.g. 0.65"
      },
      {
        "id": "nozzleAngle",
        "type": "text",
        "label": "Nozzle Spray Angle (°)",
        "placeholder": "e.g. 60"
      },
      {
        "id": "nozzlePattern",
        "type": "select",
        "label": "Nozzle Spray Pattern",
        "options": [
          "Solid (SS)",
          "Hollow (H)",
          "Semi-Solid (B)"
        ],
        "placeholder": "e.g. 60"
      },
      {
        "id": "pumpPressureBar",
        "type": "number",
        "label": "Pump Pressure (bar)",
        "placeholder": "e.g. 10"
      },
      {
        "id": "vacuumReadingMbar",
        "type": "number",
        "label": "Vacuum Reading (mbar)",
        "placeholder": "e.g. 0.8"
      },
      {
        "id": "oilLineCondition",
        "type": "select",
        "label": "Oil Line Condition",
        "options": [
          "Satisfactory",
          "Unsatisfactory",
          "Replaced"
        ]
      },
      {
        "id": "oilFilter",
        "type": "select",
        "label": "Oil Filter",
        "options": [
          "Cleaned",
          "Replaced",
          "Not Changed"
        ]
      }
    ]
  },
  {
    "id": "combustion",
    "title": "COMBUSTION TEST RESULTS",
    "repeatable": false,
    "fields": [
      {
        "id": "combustionTestPerformed",
        "type": "select",
        "label": "Combustion Test Performed",
        "options": [
          "Yes",
          "No"
        ],
        "required": true
      },
      {
        "id": "o2Pct",
        "type": "number",
        "label": "O₂ (%)",
        "placeholder": "e.g. 4.2"
      },
      {
        "id": "co2Pct",
        "type": "number",
        "label": "CO₂ (%)",
        "placeholder": "e.g. 12.6"
      },
      {
        "id": "coPpm",
        "type": "number",
        "label": "CO (ppm)",
        "placeholder": "e.g. 40"
      },
      {
        "id": "flueTempC",
        "type": "number",
        "label": "Flue Gas Temperature (°C)",
        "placeholder": "e.g. 175"
      },
      {
        "id": "ambientTempC",
        "type": "number",
        "label": "Ambient Temperature (°C)",
        "placeholder": "e.g. 20"
      },
      {
        "id": "smokeNumber",
        "type": "number",
        "label": "Smoke Number (0-9)",
        "placeholder": "0-1 normal"
      },
      {
        "id": "flueCondition",
        "type": "select",
        "label": "Flue Condition",
        "options": [
          "Satisfactory",
          "Unsatisfactory"
        ]
      }
    ]
  },
  {
    "id": "servicing",
    "title": "SERVICING CHECKS",
    "repeatable": false,
    "fields": [
      {
        "id": "burnerCleaned",
        "type": "select",
        "label": "Burner Cleaned",
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "heatExchangerCleaned",
        "type": "select",
        "label": "Heat Exchanger Cleaned",
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "electrodesChecked",
        "type": "select",
        "label": "Ignition Electrodes Checked",
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "nozzleReplaced",
        "type": "select",
        "label": "Nozzle Replaced",
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "fireValveTested",
        "type": "select",
        "label": "Fire Valve Operated & Tested",
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "fireValveTripC",
        "type": "number",
        "label": "Fire Valve Trip Temperature (°C)",
        "placeholder": "e.g. 99"
      },
      {
        "id": "scopeOfService",
        "type": "select",
        "label": "Scope of Service",
        "options": [
          "Full Service",
          "Breakdown",
          "Commissioning"
        ]
      },
      {
        "id": "faultsFound",
        "type": "textarea",
        "label": "Faults Found"
      },
      {
        "id": "workCarriedOut",
        "type": "textarea",
        "label": "Work Carried Out"
      }
    ]
  },
  {
    "id": "certification",
    "title": "CERTIFICATION & SIGN-OFF",
    "repeatable": false,
    "fields": [
      {
        "id": "serviceDate",
        "type": "date",
        "label": "Service Date",
        "required": true
      },
      {
        "id": "certificateNumber",
        "type": "text",
        "label": "Certificate Number",
        "required": true
      },
      {
        "id": "engineerSignature",
        "type": "signature",
        "label": "Engineer Signature",
        "required": true
      },
      {
        "id": "engineerPrint",
        "type": "text",
        "label": "Engineer Name (Print)",
        "required": true
      },
      {
        "id": "customerSignature",
        "type": "signature",
        "label": "Customer Signature",
        "required": true
      },
      {
        "id": "customerPrint",
        "type": "text",
        "label": "Customer Name (Print)",
        "required": true
      }
    ]
  }
]
};
